export default "__VITE_ASSET__D11zD08R__"